var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2941 3H5.88235C4.84276 3 4 3.84276 4 4.88235V17.1176C4 18.1572 4.84276 19 5.88235 19H15.2941C16.3337 19 17.1765 18.1572 17.1765 17.1176V4.88235C17.1765 3.84276 16.3337 3 15.2941 3Z",
    stroke: "#435869",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76465 7.70593H13.4117M7.76465 11.4706H13.4117M7.76465 15.2353H11.5294",
    stroke: "#435869",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcText);
export default __webpack_public_path__ + "static/media/ic-text.c23447752343f8193f397c2b6de38edf.svg";
export { ForwardRef as ReactComponent };